import { render, staticRenderFns } from "./MilestoneAwardConfigurationTab.vue?vue&type=template&id=435a2110&scoped=true&"
import script from "./MilestoneAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./MilestoneAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MilestoneAwardConfigurationTab.vue?vue&type=style&index=0&id=435a2110&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a2110",
  null
  
)

export default component.exports